const getters = {
    token: (state) => state.user.token,
    departmentName: (state) => state.user.departmentName,
    jdlbTypeId: (state) => state.declare.jdlbTypeId,
    jdlbTypeName: (state) => state.declare.jdlbTypeName,
    reportTaskInfo: (state) => state.declare.reportTaskInfo,
    comInfo: (state) => state.declare.comInfo,
    declareStepStatus: (state) => state.declare.declareStepStatus,
    nowStepStatus: (state) => state.declare.nowStepStatus,
    stepId: (state) => state.declare.stepId,
    // 特色产业园申报相关
    parkDeclareStepStatus: (state) => state.parkDeclare.declareStepStatus,
    parkNowStepStatus: (state) => state.parkDeclare.nowStepStatus,
    parkStepId: (state) => state.parkDeclare.stepId
};
export default getters;
